<template>
  <div>
    <div class="text-center">
      <carousel :images="images"></carousel>
      <div class="container cards">
        <div class="row">
          <div class="col-md-4">
            <card title="BEVEILIGING" icon="shield-alt" :awesomeicon="true" description="Slimme en gecertificeerde beveiliging en bewaking voor elk object en/of evenement. <br /><a href='https://azurity.nl/security/information/beveiliging' target='_blank'>Lees meer...</a><br /><br /><br />"></card>
          </div>
          <div class="col-md-4">
            <card title="ZORG & VERKEER" icon="clinic-medical" :awesomeicon="true" description="Het organiseren van de medische staff en het plaatsen van verkeersregelaars op kritische momenten en plaatsen. <br /><a href='https://azurity.nl' target='_blank'>Lees meer...</a><br /><br />"></card>
          </div>
          <div class="col-md-4">
            <card title="CROWDMANAGEMENT" icon="users" :awesomeicon="true" description="Systematisch analyseren om het aantal risico’s te reduceren die kunnen ontstaan wanneer zich grote groepen mensen ergens verzamelen. <br /><a href='/crowd-management'>Lees meer...</a>"></card>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 fade-in">
            <h2 class="mb-3">VEILIGHEIDS<span class="primary">TEAM</span>.NL</h2>
            <h3 class="text-muted">ALS HET OM ZORGELOZE VEILIGHEID GAAT!</h3>
          </div>
        </div>
        <div class="row mt-5 mb-3">
          <div class="col-md-4">
            <card title="RISICOSCAN" icon="exclamation-triangle" :awesomeicon="true"  description="&nbsp;</br><a class='btn btn-red btn-lg' href='/risk-analysis'>Gratis Risicoscan</a><br />&nbsp;"></card>
          </div>
          <div class="col-md-4">
            <card title="VEILIGHEIDSPLAN" icon="user-shield" :awesomeicon="true"  description="Welke maatregelen neem je om de risico's te beperken en hoe handel je in het geval van calamiteiten?<br />&nbsp;"></card>
          </div>
          <div class="col-md-4">
            <card title="CRISISBEHEER" icon="ambulance" :awesomeicon="true" description="Hoe verloopt de coördinatie en communicatie in geval van noodsituaties om de schade aan mens en materieel te beperken."></card>
          </div>
        </div>
      </div>
      <div class="bg-red fade-in">
        <div class="container pt-5 pb-5">
          <blockquote class="blockquote">
            <p class="mb-3">
              Veiligheidsteam.nl is totaal leverancier als het gaat om het organiseren van de veiligheid van een evenement, object en/of personen. Van analyse en plan, tot de uitvoering en het leveren van een ervaren team van veiligheidsprofessionals als: beveiligers, EHBO-ers, verkeersregelaars, coordinatoren en veiligheidskundigen.
            </p>
            <footer class="blockquote-footer mb-0">Totale ontzorging als het gaat om veiligheid!</footer>
          </blockquote>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel'
import Card from '@/components/Card'
export default {
  name: 'Index',
  components: {
    Carousel,
    Card
  },
  props: {
  },
  data() {
    return {
      images: [
        { image: './img/slider/slide-2-crop.webp' },
        { image: './img/slider/slide-1-crop.webp' },
        { image: './img/slider/slide-3-crop.webp' }
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      let elements = document.getElementsByClassName('fade-in');
      for(let i = 0; i < elements.length; i++)
      {
        elements[i].classList.add('visible');
      }
    }, 1);
  }
}
</script>

<style scoped> 
.cards {
  margin-top: -20px;
}

h2 {
  overflow: hidden;
}

.bg-red {
  border-top: 1px solid rgb(221, 4, 38);
  background-color: rgba(221, 4, 38, .1)
}

.fade-in
{
  opacity: 0;
    transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -webkit-transition: opacity 1s ease-in-out;
}
.fade-in.visible {
  opacity: 1;
}
</style>